<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
const props = defineProps<EditControlProps>();

let clearable = ref<boolean>(false);
let rows: number = 1;
const emitFn = defineEmits<CommonEditControlEmits>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
const uiData = reactive(ui);

config.validate = validate; // default validation funktion mit unserer von dem control überschreiben.

onMounted(() => {
  mounted(uiData, props, config);
});

function textChanged() {
  valueChanged(config, uiData, uiData.data);
}

function validate() {
  if (uiData.disabled) {
    uiData.errorText = "";
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (uiData.data) {
      uiData.errorText = "";
      return true;
    }
    uiData.errorText = config.requiredMessage;
    return false;
  }
  uiData.errorText = "";
  return true;
}
</script>
<template>
  <div class="wrap" v-if="uiData.showMutable">
    <!-- {{ uiData.description }} -->
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-textarea
          v-bind="props"
          :clearable="clearable"
          clear-icon="mdi-close-circle"
          auto-grow
          prepend-inner-icon="mdi-comment"
          :rows="rows"
          :label="uiData.description"
          v-model="uiData.data"
          @update:modelValue="textChanged"
          :disabled="uiData.disabled"
          :error-messages="uiData.errorText"
          :required="uiData.required"
          variant="outlined"
          density="compact"
          color="warning"
          persistent-hint
        ></v-textarea>

        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>
<style lang="scss" scoped></style>
